import { render, staticRenderFns } from "./add-banner-dialog.vue?vue&type=template&id=4e335b07&"
import script from "./add-banner-dialog.vue?vue&type=script&lang=js&"
export * from "./add-banner-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports